import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import Exception from '../components/Exception';

const Exception403: React.FC = () => {
  const { formatMessage } = useIntl();
  return <Exception type="403" desc={formatMessage({ id: 'app.exception.description.403' })} linkElement={Link} />;
};

export default Exception403;
